export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11582.9b8f26a4.jpg";